<div class="fc-main-content-drawer">
    <div class="fc-main-content-drawer-title">
        <span>{{ 'MAIN_CONTENT_DRAWER.TITLE' | translate }}</span>
    </div>
    <fcp-tab
        class="fc-main-content-drawer-tab"
        [type]="tabTypeEnum.Line"
        [initialValue]="selectedTab | async"
        [selectedValue]="selectedTab | async"
        (selected)="onTabChange($event)"
        [items]="[
            { text: 'MAIN_CONTENT_DRAWER.DOWNLOAD_LIST' | translate, value: contentDrawerTabs.DownloadList },
            { text: 'MAIN_CONTENT_DRAWER.MULTI_DOWNLOAD' | translate, value: contentDrawerTabs.MultiDownload }
        ]"
    ></fcp-tab>

    <div *ngIf="(selectedTab | async) === contentDrawerTabs.DownloadList" class="fc-main-content-drawer-download-list">
        <fc-download-cart [isInMainContentDrawer]="true"></fc-download-cart>
    </div>

    <div
        *ngIf="(selectedTab | async) === contentDrawerTabs.MultiDownload"
        class="fc-main-content-drawer-multi-download"
    >
        <fc-bulk-gtin-search [isInMainContentDrawer]="true"></fc-bulk-gtin-search>
    </div>
</div>
